import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';
import LogoText from '../../components/LogoText/LogoText';
import { useAuthContext } from '../../hooks/AuthContext';
import './Success.scss';
import { useControllerFlowStepsContext } from '../../hooks/ControllerFlowStepsContext';
import { CTV_SUCCESS_PAGE_PATH } from '../../data/Constants';
import { shouldOpenMenuAccount } from '../../utils/GenericFunctions';
import CookiesBanner from '../../components/CookiesBanner';

interface SuccessSignUpProps {
  context: any;
}

export default function SuccessSignUp({ context }: SuccessSignUpProps) {
  const { originDomainForm } = useContext<any>(context);
  const { redirectURL, redirectToSite } = useAuthContext();
  const { ctvCode } = useControllerFlowStepsContext();
  const url = `/${originDomainForm}/cadastro-concluido`;
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(4);
  const [hasDelayed, setHasDelayed] = useState(false);

  useEffect(() => {
    const totalTime = 4000 + 2000;
    const delayTimer = setTimeout(() => {
      setHasDelayed(true);
    }, totalTime);
    return () => clearTimeout(delayTimer);
  }, []);

  useEffect(() => {
    navigate(url, { replace: true });
  }, [navigate]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          redirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  function redirect() {
    sessionStorage.clear();
    if (ctvCode) return navigate(CTV_SUCCESS_PAGE_PATH);
    else if (shouldOpenMenuAccount(redirectURL))
      return navigate('/menu-de-conta');
    redirectToSite();
  }

  return (
    <div
      className="flex flex-column"
      style={{
        justifyContent: 'space-between',
        height: '100%',
        textAlign: 'center'
      }}
    >
      <div>
        <LogoText className="center" />
        <h4 className="color-text-default">Que bom te ver por aqui!</h4>
        <h4 className="color-text-default">Agora você tem uma Conta SBT.</h4>
      </div>

      <Button customColors="btn-ghost" full onClick={redirect}>
        <ButtonLabel>
          {hasDelayed ? 'Entrar' : `Entrando em ${countdown}`}
        </ButtonLabel>
      </Button>

      <CookiesBanner />
    </div>
  );
}
